/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicLogoutRouteImport } from './routes/_public/logout'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthenticatedImportTemplateRouteImport } from './routes/_authenticated/import-template'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedAwsMktpRouteImport } from './routes/_authenticated/aws-mktp'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedOrgSlugRouteImport } from './routes/_authenticated/$orgSlug'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account/index'
import { Route as AuthenticatedOrgSlugIndexRouteImport } from './routes/_authenticated/$orgSlug/index'
import { Route as AuthenticatedBillingOutcomeRouteImport } from './routes/_authenticated/billing.$outcome'
import { Route as AuthenticatedOrgSlugAdminRouteImport } from './routes/_authenticated/$orgSlug/admin'
import { Route as AuthenticatedOrgSlugWorkspacesIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/index'
import { Route as AuthenticatedOrgSlugAdminIndexRouteImport } from './routes/_authenticated/$orgSlug/admin/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId'
import { Route as AuthenticatedOrgSlugAdminWorkspacesRouteImport } from './routes/_authenticated/$orgSlug/admin/workspaces'
import { Route as AuthenticatedOrgSlugAdminUsersRouteImport } from './routes/_authenticated/$orgSlug/admin/users'
import { Route as AuthenticatedOrgSlugAdminBillingRouteImport } from './routes/_authenticated/$orgSlug/admin/billing'
import { Route as AuthenticatedOrgSlugAdminAuditRouteImport } from './routes/_authenticated/$orgSlug/admin/audit'
import { Route as AuthenticatedOrgSlugAdminAppsRouteImport } from './routes/_authenticated/$orgSlug/admin/apps'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/task-templates/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/settings/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/runbooks/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/reports/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/projects/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/environments/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/audit/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/approvals/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/agents/index'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/$taskId'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/reports/$reportId'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/projects/$projectId'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/$jobId'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/environments/$environmentId'
import { Route as AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRouteImport } from './routes/_authenticated/$orgSlug/workspaces/$workspaceId/agents/$agentId'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLogoutRoute = PublicLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedImportTemplateRoute =
  AuthenticatedImportTemplateRouteImport.update({
    id: '/import-template',
    path: '/import-template',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAwsMktpRoute = AuthenticatedAwsMktpRouteImport.update({
  id: '/aws-mktp',
  path: '/aws-mktp',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrgSlugRoute = AuthenticatedOrgSlugRouteImport.update({
  id: '/$orgSlug',
  path: '/$orgSlug',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedOrgSlugIndexRoute =
  AuthenticatedOrgSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedBillingOutcomeRoute =
  AuthenticatedBillingOutcomeRouteImport.update({
    id: '/billing/$outcome',
    path: '/billing/$outcome',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgSlugAdminRoute =
  AuthenticatedOrgSlugAdminRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesIndexRoute =
  AuthenticatedOrgSlugWorkspacesIndexRouteImport.update({
    id: '/workspaces/',
    path: '/workspaces/',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugAdminIndexRoute =
  AuthenticatedOrgSlugAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgSlugAdminRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteImport.update({
    id: '/workspaces/$workspaceId',
    path: '/workspaces/$workspaceId',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugAdminWorkspacesRoute =
  AuthenticatedOrgSlugAdminWorkspacesRouteImport.update({
    id: '/workspaces',
    path: '/workspaces',
    getParentRoute: () => AuthenticatedOrgSlugAdminRoute,
  } as any)
const AuthenticatedOrgSlugAdminUsersRoute =
  AuthenticatedOrgSlugAdminUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedOrgSlugAdminRoute,
  } as any)
const AuthenticatedOrgSlugAdminBillingRoute =
  AuthenticatedOrgSlugAdminBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedOrgSlugAdminRoute,
  } as any)
const AuthenticatedOrgSlugAdminAuditRoute =
  AuthenticatedOrgSlugAdminAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedOrgSlugAdminRoute,
  } as any)
const AuthenticatedOrgSlugAdminAppsRoute =
  AuthenticatedOrgSlugAdminAppsRouteImport.update({
    id: '/apps',
    path: '/apps',
    getParentRoute: () => AuthenticatedOrgSlugAdminRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRouteImport.update(
    {
      id: '/task-templates/',
      path: '/task-templates/',
      getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
    } as any,
  )
const AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRouteImport.update({
    id: '/runbooks/',
    path: '/runbooks/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRouteImport.update({
    id: '/environments/',
    path: '/environments/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRouteImport.update({
    id: '/audit/',
    path: '/audit/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRouteImport.update({
    id: '/agents/',
    path: '/agents/',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRouteImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRouteImport.update({
    id: '/jobs/$jobId',
    path: '/jobs/$jobId',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)
const AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRouteImport.update(
    {
      id: '/environments/$environmentId',
      path: '/environments/$environmentId',
      getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
    } as any,
  )
const AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRoute =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRouteImport.update({
    id: '/agents/$agentId',
    path: '/agents/$agentId',
    getParentRoute: () => AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$orgSlug': typeof AuthenticatedOrgSlugRouteWithChildren
  '/account': typeof AuthenticatedAccountRouteWithChildren
  '/aws-mktp': typeof AuthenticatedAwsMktpRoute
  '/home': typeof AuthenticatedHomeRoute
  '/import-template': typeof AuthenticatedImportTemplateRoute
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/$orgSlug/admin': typeof AuthenticatedOrgSlugAdminRouteWithChildren
  '/billing/$outcome': typeof AuthenticatedBillingOutcomeRoute
  '/$orgSlug/': typeof AuthenticatedOrgSlugIndexRoute
  '/account/': typeof AuthenticatedAccountIndexRoute
  '/$orgSlug/admin/apps': typeof AuthenticatedOrgSlugAdminAppsRoute
  '/$orgSlug/admin/audit': typeof AuthenticatedOrgSlugAdminAuditRoute
  '/$orgSlug/admin/billing': typeof AuthenticatedOrgSlugAdminBillingRoute
  '/$orgSlug/admin/users': typeof AuthenticatedOrgSlugAdminUsersRoute
  '/$orgSlug/admin/workspaces': typeof AuthenticatedOrgSlugAdminWorkspacesRoute
  '/$orgSlug/workspaces/$workspaceId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteWithChildren
  '/$orgSlug/admin/': typeof AuthenticatedOrgSlugAdminIndexRoute
  '/$orgSlug/workspaces/': typeof AuthenticatedOrgSlugWorkspacesIndexRoute
  '/$orgSlug/workspaces/$workspaceId/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRoute
  '/$orgSlug/workspaces/$workspaceId/agents/$agentId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRoute
  '/$orgSlug/workspaces/$workspaceId/environments/$environmentId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRoute
  '/$orgSlug/workspaces/$workspaceId/jobs/$jobId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRoute
  '/$orgSlug/workspaces/$workspaceId/projects/$projectId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRoute
  '/$orgSlug/workspaces/$workspaceId/reports/$reportId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRoute
  '/$orgSlug/workspaces/$workspaceId/tasks/$taskId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRoute
  '/$orgSlug/workspaces/$workspaceId/agents/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/approvals/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/audit/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRoute
  '/$orgSlug/workspaces/$workspaceId/environments/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/jobs/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/projects/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/reports/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/runbooks/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRoute
  '/$orgSlug/workspaces/$workspaceId/settings/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/task-templates/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRoute
  '/$orgSlug/workspaces/$workspaceId/tasks/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aws-mktp': typeof AuthenticatedAwsMktpRoute
  '/home': typeof AuthenticatedHomeRoute
  '/import-template': typeof AuthenticatedImportTemplateRoute
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/billing/$outcome': typeof AuthenticatedBillingOutcomeRoute
  '/$orgSlug': typeof AuthenticatedOrgSlugIndexRoute
  '/account': typeof AuthenticatedAccountIndexRoute
  '/$orgSlug/admin/apps': typeof AuthenticatedOrgSlugAdminAppsRoute
  '/$orgSlug/admin/audit': typeof AuthenticatedOrgSlugAdminAuditRoute
  '/$orgSlug/admin/billing': typeof AuthenticatedOrgSlugAdminBillingRoute
  '/$orgSlug/admin/users': typeof AuthenticatedOrgSlugAdminUsersRoute
  '/$orgSlug/admin/workspaces': typeof AuthenticatedOrgSlugAdminWorkspacesRoute
  '/$orgSlug/admin': typeof AuthenticatedOrgSlugAdminIndexRoute
  '/$orgSlug/workspaces': typeof AuthenticatedOrgSlugWorkspacesIndexRoute
  '/$orgSlug/workspaces/$workspaceId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRoute
  '/$orgSlug/workspaces/$workspaceId/agents/$agentId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRoute
  '/$orgSlug/workspaces/$workspaceId/environments/$environmentId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRoute
  '/$orgSlug/workspaces/$workspaceId/jobs/$jobId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRoute
  '/$orgSlug/workspaces/$workspaceId/projects/$projectId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRoute
  '/$orgSlug/workspaces/$workspaceId/reports/$reportId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRoute
  '/$orgSlug/workspaces/$workspaceId/tasks/$taskId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRoute
  '/$orgSlug/workspaces/$workspaceId/agents': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/approvals': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/audit': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRoute
  '/$orgSlug/workspaces/$workspaceId/environments': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/jobs': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/projects': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/reports': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/runbooks': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRoute
  '/$orgSlug/workspaces/$workspaceId/settings': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRoute
  '/$orgSlug/workspaces/$workspaceId/task-templates': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRoute
  '/$orgSlug/workspaces/$workspaceId/tasks': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/$orgSlug': typeof AuthenticatedOrgSlugRouteWithChildren
  '/_authenticated/account': typeof AuthenticatedAccountRouteWithChildren
  '/_authenticated/aws-mktp': typeof AuthenticatedAwsMktpRoute
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/import-template': typeof AuthenticatedImportTemplateRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/logout': typeof PublicLogoutRoute
  '/_authenticated/$orgSlug/admin': typeof AuthenticatedOrgSlugAdminRouteWithChildren
  '/_authenticated/billing/$outcome': typeof AuthenticatedBillingOutcomeRoute
  '/_authenticated/$orgSlug/': typeof AuthenticatedOrgSlugIndexRoute
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
  '/_authenticated/$orgSlug/admin/apps': typeof AuthenticatedOrgSlugAdminAppsRoute
  '/_authenticated/$orgSlug/admin/audit': typeof AuthenticatedOrgSlugAdminAuditRoute
  '/_authenticated/$orgSlug/admin/billing': typeof AuthenticatedOrgSlugAdminBillingRoute
  '/_authenticated/$orgSlug/admin/users': typeof AuthenticatedOrgSlugAdminUsersRoute
  '/_authenticated/$orgSlug/admin/workspaces': typeof AuthenticatedOrgSlugAdminWorkspacesRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteWithChildren
  '/_authenticated/$orgSlug/admin/': typeof AuthenticatedOrgSlugAdminIndexRoute
  '/_authenticated/$orgSlug/workspaces/': typeof AuthenticatedOrgSlugWorkspacesIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/agents/$agentId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/environments/$environmentId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/$jobId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/projects/$projectId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/reports/$reportId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/$taskId': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/agents/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/approvals/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/audit/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/environments/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/projects/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/reports/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/runbooks/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/settings/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/task-templates/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRoute
  '/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/': typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$orgSlug'
    | '/account'
    | '/aws-mktp'
    | '/home'
    | '/import-template'
    | '/login'
    | '/logout'
    | '/$orgSlug/admin'
    | '/billing/$outcome'
    | '/$orgSlug/'
    | '/account/'
    | '/$orgSlug/admin/apps'
    | '/$orgSlug/admin/audit'
    | '/$orgSlug/admin/billing'
    | '/$orgSlug/admin/users'
    | '/$orgSlug/admin/workspaces'
    | '/$orgSlug/workspaces/$workspaceId'
    | '/$orgSlug/admin/'
    | '/$orgSlug/workspaces/'
    | '/$orgSlug/workspaces/$workspaceId/'
    | '/$orgSlug/workspaces/$workspaceId/agents/$agentId'
    | '/$orgSlug/workspaces/$workspaceId/environments/$environmentId'
    | '/$orgSlug/workspaces/$workspaceId/jobs/$jobId'
    | '/$orgSlug/workspaces/$workspaceId/projects/$projectId'
    | '/$orgSlug/workspaces/$workspaceId/reports/$reportId'
    | '/$orgSlug/workspaces/$workspaceId/tasks/$taskId'
    | '/$orgSlug/workspaces/$workspaceId/agents/'
    | '/$orgSlug/workspaces/$workspaceId/approvals/'
    | '/$orgSlug/workspaces/$workspaceId/audit/'
    | '/$orgSlug/workspaces/$workspaceId/environments/'
    | '/$orgSlug/workspaces/$workspaceId/jobs/'
    | '/$orgSlug/workspaces/$workspaceId/projects/'
    | '/$orgSlug/workspaces/$workspaceId/reports/'
    | '/$orgSlug/workspaces/$workspaceId/runbooks/'
    | '/$orgSlug/workspaces/$workspaceId/settings/'
    | '/$orgSlug/workspaces/$workspaceId/task-templates/'
    | '/$orgSlug/workspaces/$workspaceId/tasks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aws-mktp'
    | '/home'
    | '/import-template'
    | '/login'
    | '/logout'
    | '/billing/$outcome'
    | '/$orgSlug'
    | '/account'
    | '/$orgSlug/admin/apps'
    | '/$orgSlug/admin/audit'
    | '/$orgSlug/admin/billing'
    | '/$orgSlug/admin/users'
    | '/$orgSlug/admin/workspaces'
    | '/$orgSlug/admin'
    | '/$orgSlug/workspaces'
    | '/$orgSlug/workspaces/$workspaceId'
    | '/$orgSlug/workspaces/$workspaceId/agents/$agentId'
    | '/$orgSlug/workspaces/$workspaceId/environments/$environmentId'
    | '/$orgSlug/workspaces/$workspaceId/jobs/$jobId'
    | '/$orgSlug/workspaces/$workspaceId/projects/$projectId'
    | '/$orgSlug/workspaces/$workspaceId/reports/$reportId'
    | '/$orgSlug/workspaces/$workspaceId/tasks/$taskId'
    | '/$orgSlug/workspaces/$workspaceId/agents'
    | '/$orgSlug/workspaces/$workspaceId/approvals'
    | '/$orgSlug/workspaces/$workspaceId/audit'
    | '/$orgSlug/workspaces/$workspaceId/environments'
    | '/$orgSlug/workspaces/$workspaceId/jobs'
    | '/$orgSlug/workspaces/$workspaceId/projects'
    | '/$orgSlug/workspaces/$workspaceId/reports'
    | '/$orgSlug/workspaces/$workspaceId/runbooks'
    | '/$orgSlug/workspaces/$workspaceId/settings'
    | '/$orgSlug/workspaces/$workspaceId/task-templates'
    | '/$orgSlug/workspaces/$workspaceId/tasks'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/$orgSlug'
    | '/_authenticated/account'
    | '/_authenticated/aws-mktp'
    | '/_authenticated/home'
    | '/_authenticated/import-template'
    | '/_public/login'
    | '/_public/logout'
    | '/_authenticated/$orgSlug/admin'
    | '/_authenticated/billing/$outcome'
    | '/_authenticated/$orgSlug/'
    | '/_authenticated/account/'
    | '/_authenticated/$orgSlug/admin/apps'
    | '/_authenticated/$orgSlug/admin/audit'
    | '/_authenticated/$orgSlug/admin/billing'
    | '/_authenticated/$orgSlug/admin/users'
    | '/_authenticated/$orgSlug/admin/workspaces'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId'
    | '/_authenticated/$orgSlug/admin/'
    | '/_authenticated/$orgSlug/workspaces/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/agents/$agentId'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/environments/$environmentId'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/$jobId'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/projects/$projectId'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/reports/$reportId'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/$taskId'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/agents/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/approvals/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/audit/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/environments/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/projects/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/reports/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/runbooks/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/settings/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/task-templates/'
    | '/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/logout': {
      id: '/_public/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof PublicLogoutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/import-template': {
      id: '/_authenticated/import-template'
      path: '/import-template'
      fullPath: '/import-template'
      preLoaderRoute: typeof AuthenticatedImportTemplateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/aws-mktp': {
      id: '/_authenticated/aws-mktp'
      path: '/aws-mktp'
      fullPath: '/aws-mktp'
      preLoaderRoute: typeof AuthenticatedAwsMktpRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$orgSlug': {
      id: '/_authenticated/$orgSlug'
      path: '/$orgSlug'
      fullPath: '/$orgSlug'
      preLoaderRoute: typeof AuthenticatedOrgSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/$orgSlug/': {
      id: '/_authenticated/$orgSlug/'
      path: '/'
      fullPath: '/$orgSlug/'
      preLoaderRoute: typeof AuthenticatedOrgSlugIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/billing/$outcome': {
      id: '/_authenticated/billing/$outcome'
      path: '/billing/$outcome'
      fullPath: '/billing/$outcome'
      preLoaderRoute: typeof AuthenticatedBillingOutcomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$orgSlug/admin': {
      id: '/_authenticated/$orgSlug/admin'
      path: '/admin'
      fullPath: '/$orgSlug/admin'
      preLoaderRoute: typeof AuthenticatedOrgSlugAdminRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/workspaces/': {
      id: '/_authenticated/$orgSlug/workspaces/'
      path: '/workspaces'
      fullPath: '/$orgSlug/workspaces/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/admin/': {
      id: '/_authenticated/$orgSlug/admin/'
      path: '/'
      fullPath: '/$orgSlug/admin/'
      preLoaderRoute: typeof AuthenticatedOrgSlugAdminIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAdminRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/$orgSlug/workspaces/$workspaceId'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/admin/workspaces': {
      id: '/_authenticated/$orgSlug/admin/workspaces'
      path: '/workspaces'
      fullPath: '/$orgSlug/admin/workspaces'
      preLoaderRoute: typeof AuthenticatedOrgSlugAdminWorkspacesRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAdminRoute
    }
    '/_authenticated/$orgSlug/admin/users': {
      id: '/_authenticated/$orgSlug/admin/users'
      path: '/users'
      fullPath: '/$orgSlug/admin/users'
      preLoaderRoute: typeof AuthenticatedOrgSlugAdminUsersRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAdminRoute
    }
    '/_authenticated/$orgSlug/admin/billing': {
      id: '/_authenticated/$orgSlug/admin/billing'
      path: '/billing'
      fullPath: '/$orgSlug/admin/billing'
      preLoaderRoute: typeof AuthenticatedOrgSlugAdminBillingRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAdminRoute
    }
    '/_authenticated/$orgSlug/admin/audit': {
      id: '/_authenticated/$orgSlug/admin/audit'
      path: '/audit'
      fullPath: '/$orgSlug/admin/audit'
      preLoaderRoute: typeof AuthenticatedOrgSlugAdminAuditRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAdminRoute
    }
    '/_authenticated/$orgSlug/admin/apps': {
      id: '/_authenticated/$orgSlug/admin/apps'
      path: '/apps'
      fullPath: '/$orgSlug/admin/apps'
      preLoaderRoute: typeof AuthenticatedOrgSlugAdminAppsRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAdminRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/'
      path: '/'
      fullPath: '/$orgSlug/workspaces/$workspaceId/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/'
      path: '/tasks'
      fullPath: '/$orgSlug/workspaces/$workspaceId/tasks/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/task-templates/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/task-templates/'
      path: '/task-templates'
      fullPath: '/$orgSlug/workspaces/$workspaceId/task-templates/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/settings/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/settings/'
      path: '/settings'
      fullPath: '/$orgSlug/workspaces/$workspaceId/settings/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/runbooks/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/runbooks/'
      path: '/runbooks'
      fullPath: '/$orgSlug/workspaces/$workspaceId/runbooks/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/reports/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/reports/'
      path: '/reports'
      fullPath: '/$orgSlug/workspaces/$workspaceId/reports/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/projects/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/projects/'
      path: '/projects'
      fullPath: '/$orgSlug/workspaces/$workspaceId/projects/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/'
      path: '/jobs'
      fullPath: '/$orgSlug/workspaces/$workspaceId/jobs/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/environments/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/environments/'
      path: '/environments'
      fullPath: '/$orgSlug/workspaces/$workspaceId/environments/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/audit/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/audit/'
      path: '/audit'
      fullPath: '/$orgSlug/workspaces/$workspaceId/audit/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/approvals/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/approvals/'
      path: '/approvals'
      fullPath: '/$orgSlug/workspaces/$workspaceId/approvals/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/agents/': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/agents/'
      path: '/agents'
      fullPath: '/$orgSlug/workspaces/$workspaceId/agents/'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/$taskId': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/$orgSlug/workspaces/$workspaceId/tasks/$taskId'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/reports/$reportId': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/$orgSlug/workspaces/$workspaceId/reports/$reportId'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/projects/$projectId': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/$orgSlug/workspaces/$workspaceId/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/$jobId': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/$orgSlug/workspaces/$workspaceId/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/environments/$environmentId': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/environments/$environmentId'
      path: '/environments/$environmentId'
      fullPath: '/$orgSlug/workspaces/$workspaceId/environments/$environmentId'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
    '/_authenticated/$orgSlug/workspaces/$workspaceId/agents/$agentId': {
      id: '/_authenticated/$orgSlug/workspaces/$workspaceId/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/$orgSlug/workspaces/$workspaceId/agents/$agentId'
      preLoaderRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute
    }
  }
}

interface AuthenticatedOrgSlugAdminRouteChildren {
  AuthenticatedOrgSlugAdminAppsRoute: typeof AuthenticatedOrgSlugAdminAppsRoute
  AuthenticatedOrgSlugAdminAuditRoute: typeof AuthenticatedOrgSlugAdminAuditRoute
  AuthenticatedOrgSlugAdminBillingRoute: typeof AuthenticatedOrgSlugAdminBillingRoute
  AuthenticatedOrgSlugAdminUsersRoute: typeof AuthenticatedOrgSlugAdminUsersRoute
  AuthenticatedOrgSlugAdminWorkspacesRoute: typeof AuthenticatedOrgSlugAdminWorkspacesRoute
  AuthenticatedOrgSlugAdminIndexRoute: typeof AuthenticatedOrgSlugAdminIndexRoute
}

const AuthenticatedOrgSlugAdminRouteChildren: AuthenticatedOrgSlugAdminRouteChildren =
  {
    AuthenticatedOrgSlugAdminAppsRoute: AuthenticatedOrgSlugAdminAppsRoute,
    AuthenticatedOrgSlugAdminAuditRoute: AuthenticatedOrgSlugAdminAuditRoute,
    AuthenticatedOrgSlugAdminBillingRoute:
      AuthenticatedOrgSlugAdminBillingRoute,
    AuthenticatedOrgSlugAdminUsersRoute: AuthenticatedOrgSlugAdminUsersRoute,
    AuthenticatedOrgSlugAdminWorkspacesRoute:
      AuthenticatedOrgSlugAdminWorkspacesRoute,
    AuthenticatedOrgSlugAdminIndexRoute: AuthenticatedOrgSlugAdminIndexRoute,
  }

const AuthenticatedOrgSlugAdminRouteWithChildren =
  AuthenticatedOrgSlugAdminRoute._addFileChildren(
    AuthenticatedOrgSlugAdminRouteChildren,
  )

interface AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteChildren {
  AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRoute
}

const AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteChildren: AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteChildren =
  {
    AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsAgentIdRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsEnvironmentIdRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsJobIdRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsProjectIdRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsReportIdRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksTaskIdRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdAgentsIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdApprovalsIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdAuditIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdEnvironmentsIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdJobsIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdProjectsIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdReportsIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdRunbooksIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdSettingsIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdTaskTemplatesIndexRoute,
    AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRoute:
      AuthenticatedOrgSlugWorkspacesWorkspaceIdTasksIndexRoute,
  }

const AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteWithChildren =
  AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute._addFileChildren(
    AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteChildren,
  )

interface AuthenticatedOrgSlugRouteChildren {
  AuthenticatedOrgSlugAdminRoute: typeof AuthenticatedOrgSlugAdminRouteWithChildren
  AuthenticatedOrgSlugIndexRoute: typeof AuthenticatedOrgSlugIndexRoute
  AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute: typeof AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteWithChildren
  AuthenticatedOrgSlugWorkspacesIndexRoute: typeof AuthenticatedOrgSlugWorkspacesIndexRoute
}

const AuthenticatedOrgSlugRouteChildren: AuthenticatedOrgSlugRouteChildren = {
  AuthenticatedOrgSlugAdminRoute: AuthenticatedOrgSlugAdminRouteWithChildren,
  AuthenticatedOrgSlugIndexRoute: AuthenticatedOrgSlugIndexRoute,
  AuthenticatedOrgSlugWorkspacesWorkspaceIdRoute:
    AuthenticatedOrgSlugWorkspacesWorkspaceIdRouteWithChildren,
  AuthenticatedOrgSlugWorkspacesIndexRoute:
    AuthenticatedOrgSlugWorkspacesIndexRoute,
}

const AuthenticatedOrgSlugRouteWithChildren =
  AuthenticatedOrgSlugRoute._addFileChildren(AuthenticatedOrgSlugRouteChildren)

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedOrgSlugRoute: typeof AuthenticatedOrgSlugRouteWithChildren
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
  AuthenticatedAwsMktpRoute: typeof AuthenticatedAwsMktpRoute
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedImportTemplateRoute: typeof AuthenticatedImportTemplateRoute
  AuthenticatedBillingOutcomeRoute: typeof AuthenticatedBillingOutcomeRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOrgSlugRoute: AuthenticatedOrgSlugRouteWithChildren,
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
  AuthenticatedAwsMktpRoute: AuthenticatedAwsMktpRoute,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedImportTemplateRoute: AuthenticatedImportTemplateRoute,
  AuthenticatedBillingOutcomeRoute: AuthenticatedBillingOutcomeRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicLogoutRoute: typeof PublicLogoutRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicLogoutRoute: PublicLogoutRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
